/* eslint-disable */
import config from '@/resources'

const state = {
    api_key: '',
    cc: '',
    company_uuid: '',
    lang: '',
    platform: '',
    msisdn: null,
    userId: null,
    access_token: null,
    uvid: null,
    redirect_url: null,
    period_id: null,
}

const actions = {
    set({ commit }, settings) {
        const { platform, company_uuid, cc, lang, api_key, msisdn, userId, access_token, uvid, redirect_url, period_id } = settings

        commit('SET', {
            platform,
            company_uuid,
            cc,
            lang,
            api_key,
            msisdn,
            userId,
            access_token,
            uvid,
            redirect_url,
            period_id,
        })
    },

    setOne({ commit }, valueObject) {
        commit('SET', valueObject)
    },
}

const mutations = {
    SET(state, settings) {
        Object.assign(state, settings)
    },
}

const getters = {
    hasRequiredParameters(state) {
        const settings = Object.values(state)
        return settings.every((value) => value !== '')
    },

    get(state) {
        return {
            ...state
        }
    },

    getClient(state) {
        const id = state.company_uuid.split('_')
            .pop()

        if (Object.keys(config).includes(id)) {
            return config[id]
        }

        throw new Error('Client ID doesn\'t exist.')
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
